export const Location = [
  {
    id: 1,
    city: 'La Paz',
    street: 'C. Lazaro de Ribera # 912',
    tel: 'Telf. Pedidos: 12345678'
  },
  {
    id: 2,
    city: 'La Paz',
    street: 'Av. Arce 2799 Ed. Fortaleza P.5 #876',
    tel: 'Telf. Pedidos: 12345678'
  },
  {
    id: 3,
    city: 'El Alto',
    street: 'Pza. 25 de Julio Av. Principal #332',
    tel: 'Telf. Pedidos: 12345678'
  },
  {
    id: 4,
    city: 'Cochabamba',
    street: 'Av. Suecia # 3013 frente Mdo. 15 de Abril',
    tel: 'Telf. Pedidos: 12345678'
  },
  {
    id: 5,
    city: 'Santa Cruz',
    street: 'Av. Piraí # 461 esq. Moile',
    tel: 'Telf. Pedidos: 12345678'
  },
  {
    id: 6,
    city: 'Trinidad',
    street: 'C. Santiago de Chiquitos s/n, Puerto Suárez #999',
    tel: 'Telf. Pedidos: 12345678'
  }
]